import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import SaveIcon from '@mui/icons-material/Save';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import SentimentVerySatisfiedIcon from '@mui/icons-material/SentimentVerySatisfied';
import {
  Avatar,
  Chip,
  CircularProgress,
  IconButton,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import * as React from 'react';
import * as Redux from 'react-redux';
import { getFilesArchivos } from '../../../archivos/HelpersArchivos';
import { LOADING_ALL_ASISTENCIAS_DIARIAS } from '../../../control_estudios/asistencias/AsistenciasReducer';
import { ACTIVO_ESTUDIANTES } from '../../../control_estudios/estudiantes/EstudiantesReducer';
import { saveNotasBlopedAction } from '../NotasBlopedAction';

const TableEstudiantesNotasComponent = () => {
  const dispatch = Redux.useDispatch();

  const notasBlopedStore = Redux.useSelector((state) => state.notasBloped);
  const estudiantesStore = Redux.useSelector((state) => state.estudiantes);
  const asistenciasStore = Redux.useSelector((state) => state.asistencias);

  const idPlanEva = notasBlopedStore.planEvaluacion?.id ?? null;

  const [rows, setRows] = React.useState([]);
  const [notas, setNotas] = React.useState([]);
  const [loadingSave, setLoadingSave] = React.useState(false);
  const [dataSave, setDataSave] = React.useState(null);

  React.useEffect(() => {
    if (idPlanEva === null) return;
    let lR = [];
    const lN = [];
    notasBlopedStore.all.forEach((el) => {
      lR.push(el);
      lN.push({
        estudiante: el.id,
        planEvaluacion: idPlanEva,
        nota: el.nota?.nota ?? 0,
        asistencias: el.nota?.asistencias ?? 0,
        inasistencias: el.nota?.inasistencias ?? 0,
      });
    });
    setRows(lR);
    setNotas(lN);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notasBlopedStore.all]);

  React.useEffect(() => {
    notasBlopedStore.all.forEach((el, index) => {
      let d = notas[index];

      if (d?.nota > 0) return;

      let totalNota = 0;

      const estData = notasBlopedStore.allEstudiantesPlan.find(
        (item) => item.id === el.id,
      );

      if (estData) {
        let nota = 0;
        estData.notasEvaluativas.forEach((item) => {
          totalNota = totalNota + Number(item.nota);
        });
        nota = Math.round(totalNota / estData.notasEvaluativas.length);
        setDataNota(el.id, { nota });
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notasBlopedStore.allEstudiantesPlan]);

  React.useEffect(() => {
    dispatch({
      type: LOADING_ALL_ASISTENCIAS_DIARIAS,
      payload: true,
    });
    notasBlopedStore.all.forEach((el, index) => {
      let d = notas[index];

      if (d?.asistencias > 0) return;

      const estAsis = asistenciasStore.allEstudiantesAsistencias.find(
        (item) => item.id === el.id,
      );

      if (estAsis) {
        let asis = 0;
        estAsis.horarios.forEach((item) => {
          asis = asis + item.asistencias.length;
        });
        setDataNota(el.id, { asis });
      }
    });
    dispatch({
      type: LOADING_ALL_ASISTENCIAS_DIARIAS,
      payload: false,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [asistenciasStore.allEstudiantesAsistencias]);

  function setDataNota(id, { nota, asis, ina }) {
    const d = notas.find((el) => el.estudiante === id);

    if (!d) return;

    let index;

    notas.some((el, i) => {
      if (d.estudiante === el.estudiante) {
        index = i;
        return true;
      }
      return null
    });

    if (nota) d['nota'] = Number(nota);
    if (asis) d['asistencias'] = Number(asis);
    if (ina) d['inasistencias'] = Number(ina);

    const l = notas;
    l[index] = d;
    setNotas(l);
  }

  return (notasBlopedStore.loadingAll || asistenciasStore.loadingAll) &&
    !loadingSave ? (
    <Typography color="initial" sx={{ fontSize: 14 }}>
      Procesando información...
    </Typography>
  ) : (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>ESTUDIANTES</TableCell>
            <TableCell align="left" wid>
              {notasBlopedStore.planEvaluacion.fechaBloque.bloquePedagogico
                .nombre ?? 'N/A'}
            </TableCell>
            <TableCell align="left">ASISTENCIAS</TableCell>
            <TableCell align="left">INASISTENCIAS</TableCell>
            <TableCell align="left">ACCIÓN</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((el, index) => {
            let d = notas[index];

            return (
              <TableRow
                key={index}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Avatar
                      alt={el.usuario.perfil.pnombre}
                      sx={{ width: 30, height: 30 }}
                      src={getFilesArchivos(el.usuario.perfil.avatar)}
                    />
                    <Typography>
                      {el.usuario.perfil.tipoDni}
                      {'-'}
                      {el.usuario.perfil.dni} {el.usuario.perfil.pnombre}{' '}
                      {el.usuario.perfil.papellido}
                      {estudiantesStore.activo?.id === el.id ? (
                        <>
                          <Chip label="Activo" size="small" color="success" />
                          <IconButton
                            aria-label="detalle"
                            size="small"
                            color="error"
                            onClick={async () => {
                              dispatch({
                                type: ACTIVO_ESTUDIANTES,
                                payload: null,
                              });
                            }}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </>
                      ) : null}
                    </Typography>
                    {el.id === dataSave?.estudiante && loadingSave ? (
                      <CircularProgress size="1rem" />
                    ) : null}
                  </Stack>
                </TableCell>
                <TableCell align="left">
                  <Stack direction="row" spacing={1} alignItems="center">
                    <TextField
                      id="outlined-bloque"
                      type="number"
                      size="small"
                      defaultValue={d?.nota ?? 0}
                      disabled={notasBlopedStore.isDisabledData}
                      InputProps={{
                        inputProps: { min: 0, max: 20 },
                        style: {
                          height: '30px',
                        },
                      }}
                      onChange={(e) =>
                        setDataNota(el.id, { nota: e.target.value })
                      }
                    />

                    {el.nota ? (
                      d.nota > 14 ? (
                        <SentimentVerySatisfiedIcon color="success" />
                      ) : d.nota >= 10 && d.nota < 15 ? (
                        <SentimentDissatisfiedIcon color="warning" />
                      ) : (
                        <SentimentVeryDissatisfiedIcon color="error" />
                      )
                    ) : null}
                  </Stack>
                </TableCell>
                <TableCell align="left">
                  <TextField
                    id="outlined-asistencias"
                    type="number"
                    size="small"
                    defaultValue={d?.asistencias ?? 0}
                    disabled={notasBlopedStore.isDisabledData}
                    InputProps={{
                      inputProps: { min: 0, max: 100 },
                      style: {
                        height: '30px',
                      },
                    }}
                    onChange={(e) =>
                      setDataNota(el.id, { asis: e.target.value })
                    }
                  />
                </TableCell>
                <TableCell align="left">
                  <TextField
                    id="outlined-inasistencias"
                    type="number"
                    size="small"
                    defaultValue={d?.inasistencias ?? 0}
                    disabled={notasBlopedStore.isDisabledData}
                    InputProps={{
                      inputProps: { min: 0, max: 100 },
                      style: {
                        height: '30px',
                      },
                    }}
                    onChange={(e) =>
                      setDataNota(el.id, { ina: e.target.value })
                    }
                  />
                </TableCell>
                <TableCell align="left">
                  <IconButton
                    aria-label="guardar"
                    size="small"
                    onClick={async () => {
                      setLoadingSave(true);
                      setDataSave(d);
                      await saveNotasBlopedAction(
                        dispatch,
                        el.nota?.id,
                        d,
                        notasBlopedStore.params,
                      );
                      setDataSave(null);
                      setLoadingSave(false);
                    }}
                    color={el.nota ? 'primary' : 'success'}
                  >
                    {el.nota ? (
                      <EditIcon fontSize="small" />
                    ) : (
                      <SaveIcon fontSize="small" />
                    )}
                  </IconButton>
                  <IconButton
                    aria-label="detalle"
                    size="small"
                    onClick={async () => {
                      dispatch({
                        type: ACTIVO_ESTUDIANTES,
                        payload: el,
                      });
                    }}
                  >
                    <PersonSearchIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableEstudiantesNotasComponent;
